<template>
  <div id="notFound">
    404
  </div>
</template>

<script>

export default {
  name: 'notFound'
};
</script>

<style scoped>
#notFound { display: flex; align-items: center; justify-content: center; color: rgba(153, 30, 102, 1); font-size: 23vw}
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #notFound { display: flex; align-items: center; justify-content: center; color: rgba(153, 30, 102, 1); font-size: 60px}
}

</style>
